<ul *ngIf="actions?.length">
  <li *ngFor="let action of actions; let i = index">
    <a *ngIf="action !== null" (click)="onAction(action)"><mdi [name]="action.icon"></mdi> {{ action.name }}</a>
    <span *ngIf="action === null && i">&nbsp;</span>
  </li>
</ul>
